import { Configuration, FrontendApi } from '@ory/client-fetch';

const kratosUrl = import.meta.env.VITE_KRATOS_URL || 'http://localhost:4433';

export const kratos = new FrontendApi(
  new Configuration({
    basePath: kratosUrl,
    credentials: 'include',
    // Browser endpoints 303 to the settings UI unless they see this; fetch then
    // follows the redirect to Vite, which has no CORS headers.
    headers: {
      Accept: 'application/json',
    },
  })
);
